import request from '@/sheep/request';

/**
 * 微信小程序虚拟支付 API
 */
const PayVirtualApi = {
  /**
   * 获取虚拟支付签名
   * @param data 虚拟支付请求参数
   */
  getVirtualPaySignature: (data: {
    orderId: number;
    openid: string;
    goodsName?: string;
    buyQuantity: number;
    productId?: string;
    goodsPrice?: number;
  }) => {
    return request({
      url: '/pay/virtual/signature',
      method: 'POST',
      data,
    });
  },
};

export default PayVirtualApi;
